<div id="forgot-password" class="flex flex-col" fusePerfectScrollbar>
  <div
    id="forgot-password-form-wrapper"
    class="flex flex-col items-center justify-center"
    *fuseIfOnDom
    [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
    <div id="forgot-password-form">
      <div class="logo">
        <img src="assets/images/logos/fuse.svg" />
      </div>

      <div i18n class="title">ВОССТАНОВИТЬ ПАРОЛЬ</div>

      <form name="forgotPasswordForm" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" novalidate>
        <mat-form-field appearance="outline">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" />
          <mat-error i18n *ngIf="forgotPasswordFormErrors.email.required">Email не задан</mat-error>
          <mat-error i18n *ngIf="!forgotPasswordFormErrors.email.required && forgotPasswordFormErrors.email.email"
            >Пожалуйста введите действительный Email</mat-error
          >
        </mat-form-field>

        <button
          i18n
          mat-raised-button
          class="submit-button"
          color="accent"
          aria-label="SEND RESET LINK"
          [disabled]="forgotPasswordForm.invalid"
          >ОТПРАВИТЬ ССЫЛКУ</button
        >
      </form>

      <div class="login" *ngIf="userId">
        <a i18n class="link" [routerLink]="['/client/auth/login']" [queryParams]="{ user: userId }"
          >Вернуться на страницу авторизации</a
        >
      </div>
    </div>
  </div>
</div>
